// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import FileUploadWorker from "worker-loader!@scrile/tools/dist/lib/FileUploader.worker.js";
import { FileUploader } from "@scrile/tools/dist";
import { UploadProgress } from "@scrile/tools/dist/lib/FileUploader";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS, FILE_UPLOADING_FINALLY_PROCESSING } from "@/const";

const fileUploader = new FileUploader(config.s3UploadUrl, {
  chunkUpload: true,
  useWebWorker: config.featureFileUploaderWebWorker,
  workerFactory: () => new FileUploadWorker(),
});
// with chunkUpload the library uploads one file at a time. A photo set of 70 small files then took 2.5 minutes, each
// file waiting for the round trips of the one before it. Several files go in parallel; a big file is still split into
// parts by the library (CO-15592)
const PARALLEL_UPLOADS = 4;
Object.assign(fileUploader, { maxParallelUploads: PARALLEL_UPLOADS });

const originalUpload = fileUploader.upload;
export const showDefaultUploadError = () => emitter.emit(EVENTS.STATUS_SHOW, { text: "File upload error" });

fileUploader.upload = function(fileList) {
  return originalUpload.call(fileUploader, fileList).catch(e => {
    showDefaultUploadError();
    throw e;
  });
};

export const calculateProgress = (data: UploadProgress): number => {
  const res = Math.floor(((data.loaded ?? 0) / (data.total ?? 0)) * 100);
  return res === 100 ? FILE_UPLOADING_FINALLY_PROCESSING : res;
};

export default fileUploader;
